import { InitOptions } from "i18next";
import { newUIResources } from "./output-resources/newui/resources";

const internationalizationOptions: InitOptions = {
    resources: newUIResources,
    lng: "en-US",
    fallbackLng: 'en-US',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false // react already safes from xss
    }
}
const withOwnInternationalizationOptions = (options: InitOptions): InitOptions => ({
    ...internationalizationOptions,
    ...options

})
export { internationalizationOptions, withOwnInternationalizationOptions }